import { createGate } from 'effector-react';

import { root } from '../root';

export const RootGate = createGate<void>({ domain: root });
